import type { Filter, FilterDataSwitch } from '@/app/common/filters/core/filtersTypes';

export const FilterSwitchPill = (filter: Filter): string[] => {
  const data = filter.data as FilterDataSwitch;
  return data.selected ? [data.label] : [];
};
